import { FunctionComponent } from 'react';
import { Stack, Typography } from '@mui/material';

export const IntroText: FunctionComponent<
    React.PropsWithChildren<unknown>
> = () => {
    return (
        <Stack spacing={3}>
            <Typography>
                Machen Sie rabattierte Tickets (Spezialtarife) im Webshop nur
                für bestimmte Gästegruppen sichtbar und buchbar.
            </Typography>

            <ul>
                <li>
                    <Typography>
                        z.B. Saisonkarten für Skilehrer, „Einheimischentarife“,
                        rabattierte Tickets für Behinderte, Bonus für Ihre
                        Stammkunden, usw.
                    </Typography>
                </li>
                <li>
                    <Typography>
                        Nur Gäste, welche von Ihnen einen Freigabecode für
                        dieses rabattierte Ticket erhalten und diesen Code auf
                        ihrer Keycard registrieren, können das Ticket online
                        sehen und buchen. Und das so lang, bis Sie das
                        rabattierte Ticketangebot wieder aus dem Onlineverkauf
                        nehmen.
                    </Typography>
                </li>
            </ul>

            <Typography variant='h6'>Ablauf</Typography>

            <ol>
                <li>
                    <Typography>
                        Legen Sie hier eine Freigabegruppe mit der gewünschten
                        Anzahl an Freigabecodes für Ihre Gäste an. Unser Tipp:
                        Wählen Sie eine einfachen Gruppennamen.
                    </Typography>
                </li>

                <li>
                    <Typography>
                        Stellen Sie dann über SKIDATA oder AXESS ein
                        rabattiertes Ticketangebot im Webshop ein. Wichtig:
                        Wählen Sie eine eindeutige Ticketbeschreibung in
                        Internettextfeld, die sich von allen anderen Tickets
                        unterscheidet! (Die Beschreibung kann später von
                        starjack geändert werden.) Dies ist grundlegend für den
                        nächsten Schritt:
                    </Typography>
                </li>

                <li>
                    <Typography>
                        Notieren Sie den Namen Ihrer Freigabegruppe und wechseln
                        Sie zum Menü „Produktkonfiguration“ (hier im
                        Adminbereich). Öffnen Sie über „bearbeiten“ die
                        Konfiguration des rabattierten Tickets. Geben Sie im
                        Feld „Freigabegruppen hinterlegen“ den Namen der
                        Freigabegruppe, die Sie hier zuvor angelegt haben, ein.
                        Damit sperren Sie die Sichtbarkeit des Angebotes im
                        Webshop. Und Sie verknüpfen die Freigabecodes mit Ihrem
                        Sonderangebot. <br />
                        Die Anzahl der Freigabe-Codes können Sie hier auch im
                        Nachhinein noch erhöhen, falls Sie weitere Codes
                        benötigen.
                    </Typography>
                </li>

                <li>
                    <Typography>
                        Geben Sie die Freigabecodes an Ihre Gäste aus. Nur
                        Gäste, an denen Sie einen Code dieser Freigabe-Gruppe
                        ausgeben, können dieses rabattierte Ticket im Webshop
                        einsehen und buchen. Und zwar so lang, wie Sie ihr
                        Ticketangebot zum Kauf anbieten.
                    </Typography>
                </li>
            </ol>

            <Typography
                sx={{
                    fontWeight: 600,
                }}
                gutterBottom
            >
                Der Gast registriert über sein Webshop Konto den Freigabecode
                auf einer Keycard. Nur mit dieser Keycard kann Ihr Spezialtarif
                gebucht werden. (keine andere Buchungsoption möglich)
            </Typography>

            <Typography
                sx={{
                    fontWeight: 600,
                }}
                gutterBottom
            >
                Auch wenn der Gast mehrere Keycards in seinem Webshop Konto hat,
                kann der Spezialtarif nur auf die Keycard(s) gebucht, welche mit
                einen Freigabecode dafür aktiviert sind.
            </Typography>

            <Typography
                sx={{
                    textAlign: 'center',
                }}
            >
                Nutzen Sie einen Freigabe-Code und testen Sie über Ihren
                starjack Useraccount die Sichtbarkeit / Funktionalität.
            </Typography>
        </Stack>
    );
};
